export default "__VITE_ASSET__BHIfpGnU__"